import React, {PureComponent} from 'react';
import {Helmet} from 'react-helmet';

import intl from 'react-intl-universal';
import {Button} from 'components';


import styles from './styles';

import image1 from './assets/crop-page-1.jpg';
import image2 from './assets/crop-page-2.jpg';


class CropImages extends PureComponent {
  
    handleGetStartedClick = () => {
      const { history, linkLocation } = this.props;
  
      history.push(linkLocation || '/');
    };
    render() {
      return (
        <div>
          <Helmet>
            <title>{intl.get('CropImages.PageHeader')}</title>
            <meta
              name="description"
              content="Online tool to easily crop photos. Use a custom aspect ratio or crop freely to adjust your photo compositions."
            />
          </Helmet>
          <div className={`${styles.masthead} container`}>
            <div>
              <h2>{intl.get('CropImages.PageHeader')}</h2>
              <p>{intl.get('CropImages.PageHeaderDescription')}</p>
            </div>
            <Button className='accent-button' onClick={this.handleGetStartedClick}>
              {intl.get('Get Started')}
            </Button>
          </div>
          <div className='container'>
            <div className='twoSections verticallyCentered content'>
              <div className="section">
                <h2>{intl.get('CropImages.CreateBetterCompositions')}</h2>
                <p>{intl.get('CropImages.CreateBetterCompPara1')}</p>
                <p>{intl.get('CropImages.CreateBetterCompPara2')}</p>
              </div>
              <div className='section'>
                <img className={styles.featureImage} src={image1} alt="" />
              </div>
            </div>
          </div>
          <div className='darkSection'>
            <div className='twoSections verticallyCentered container'>
              <div className='section'>
                <img className={styles.featureImage} src={image2} alt="" />
              </div>
              <div className="section">
                <h2>{intl.get('CropImages.CropFreeStyleUseAnAspect')}</h2>
                <p>{intl.get('CropImages.CropFreeStyleUseAnAspectPara1')}</p>
                <p>{intl.get('CropImages.CropFreeStyleUseAnAspectPara2')}</p>
              </div>
            </div>
          </div>
          <div className='container'>
            <div className="center section">
                <h2>{intl.get('CropImages.HowToCropPhoto')}</h2>
                <p>{intl.get('CropImages.HowToCropPhotoAns')}</p>
            </div>
          </div>
          <div className={styles.howToGrid}>
            <div className={styles.howToItem}>
              <div className={styles.step}>{intl.get('01')}</div>
              <div>
                <p>{intl.get('CropImages.Step1Para')}</p>
            </div>
            </div>
            <div className={styles.howToItem}>
              <div className={styles.step}>{intl.get('02')}</div>
              <div>
                <p>{intl.get('CropImages.Step2Para')}</p>
            </div>
            </div>
            <div className={styles.howToItem}>
              <div className={styles.step}>{intl.get('03')}</div>
              <div>
                <p>{intl.get('CropImages.Step3Para')}</p>
            </div>
            </div>
            <div className={styles.howToItem}>
              <div className={styles.step}>{intl.get('04')}</div>
              <div>
                <p>{intl.get('CropImages.Step4Para')}</p>
            </div>
            </div>
          </div>
        </div>
      )
    }
  }

export default CropImages;



// WEBPACK FOOTER //
// ./src/containers/Features/CropImages.jsx